import React from 'react';
import styled from 'styled-components';
import AdminLayout from 'Components/Layout/AdminLayout';
import AdminOrganizationMessagesComponent from 'Components/AdminPage/AdminOrganizationMessages';

const ContentContainer = styled.div`
  width: 100%;
  margin: 20px;
  overflow: auto;
  flex: 1;
`;

const AdminOrganizationMessages = () => {
  return (
    <AdminLayout>
      <ContentContainer>
        <AdminOrganizationMessagesComponent />
      </ContentContainer>
    </AdminLayout>
  );
};
export default AdminOrganizationMessages;
